export enum Region {
  US = 'us',
  CA = 'ca',
}

export enum ServiceMode {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
}

export const DEFAULT_RESTAURANT_ID = '0';
